export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "button": {
          "signUpNow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign Up Now"])}
        }
      },
      "ru": {
        "button": {
          "signUpNow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Записаться сейчас"])}
        }
      },
      "es": {
        "button": {
          "signUpNow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Regístrate ahora"])}
        }
      },
      "kk": {
        "button": {
          "signUpNow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Қазір тіркелу"])}
        }
      },
      "uz": {
        "button": {
          "signUpNow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hozir ro'yxatdan o'ting"])}
        }
      },
      "de": {
        "button": {
          "signUpNow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jetzt anmelden"])}
        }
      },
      "fr": {
        "button": {
          "signUpNow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inscrivez-vous maintenant"])}
        }
      },
      "it": {
        "button": {
          "signUpNow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iscriviti ora"])}
        }
      }
    }
  })
}
